// extracted by mini-css-extract-plugin
export var button = "_dt-0";
export var icon = "_dt-1";